import { Box, Card, CardContent } from '@mui/material';
import React from 'react';
import NewPasswordModal from 'src/pages/authentication/components/forgottenPassword/NewPasswordModal';
import { LoginJWT } from 'src/pages/authentication/components/login';

interface CardLoginProps {
  titleComponent: React.ReactNode;
  children?: React.ReactNode;
  onlyDtDomain: boolean;
}
const CardLogin = ({
  titleComponent,
  children,
  onlyDtDomain,
}: CardLoginProps) => {
  return (
    <Card
      sx={{
        width: '350px',
        height: 'auto',
        boxShadow: 1,
        transition: 'all 400ms ease',
        '&:hover': {
          transition: 'all 400ms ease-in',
          boxShadow: 2,
        },
        '@media screen and (max-width: 374px)': {
          width: '260px',
        },
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: 4,
          gap: '1rem',
        }}
      >
        {titleComponent}
        <Box
          sx={{
            flexGrow: 1,
            mt: 3,
          }}
        >
          <LoginJWT OnlyDtDomain={onlyDtDomain} />
        </Box>
        <NewPasswordModal />
        {children && React.Children.map(children, (child) => child)}
      </CardContent>
    </Card>
  );
};

export default CardLogin;
